"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EvCreditTag_1 = __importDefault(require("./EvCreditTag"));
var GreatDealTag_1 = __importDefault(require("./GreatDealTag"));
var NewPriceTag_1 = __importDefault(require("./NewPriceTag"));
var usePriceDrop_1 = __importDefault(require("../../../hooks/usePriceDrop"));
var TileDataContext_1 = require("../../TileDataContext");
var TileFunctions_1 = require("../../TileFunctions");
function DealTags() {
    var tileData = (0, TileDataContext_1.useTileDataContext)().tileData;
    var showGreatDeal = (0, TileFunctions_1.maybeHasGreatDealTag)(tileData);
    var getPriceDrop = (0, usePriceDrop_1.default)().getPriceDrop;
    var showPriceDrop = getPriceDrop(tileData).showPriceDrop;
    var showEvTag = (0, TileFunctions_1.hasCleanTaxCredit)(tileData);
    //TODO if no tags display the old carvana certified/partner tag
    return (react_1.default.createElement("div", { className: "flex gap-4" },
        showPriceDrop && react_1.default.createElement(NewPriceTag_1.default, null),
        showGreatDeal && react_1.default.createElement(GreatDealTag_1.default, null),
        showEvTag && react_1.default.createElement(EvCreditTag_1.default, null)));
}
exports.default = DealTags;
//# sourceMappingURL=DealTags.js.map